import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Row,
	Col,
	Alert
} from 'react-bootstrap';

import LayoutPrivate from '../../../../components/Layout/Private';
import {handleChange, setTitle} from '../../../../util/common';
import {
	Select,
	Form,
	File
} from '../../../../components/Form';
import {ImportFileType} from '../../../../util/types';
import {Status} from '../../../../components/Other';
import {SuccessMessageTimeout} from '../../../../util/globals';

class ImportCalculatorDefinition extends Component {
	state = {
		success: false,
		invalid: false,
		type: '',
		file: null
	}

	componentDidMount() {
		setTitle(['Kalkulatory', 'Zaimportuj nową definicję']);
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.imported && this.props.imported) {
			this.props.getCalculatorDefinition();

			this.setState({
				success: true
			}, () => {
				setTimeout(() => {
					this.setState({
						success: false
					});

					this.props.history.push('/calculator/definition/set');
				}, SuccessMessageTimeout);
			});
		}
	}

	handleError = () => {
		this.setState({
			invalid: true,
			success: false
		});
	}

	handleSubmit = () => {
		const {
			importCalculatorDefinition,
			loading
		} = this.props;

		const {
			type,
			file
		} = this.state;

		if (loading) return false;

		this.setState({
			invalid: false,
			success: false
		});

		importCalculatorDefinition({
			type,
			file
		});

		return true;
	};

	handleChange = (name, value) => handleChange(this, name, value);

	render() {
		const {loading, error} = this.props;
		const {
			success,
			invalid,
			type,
			file
		} = this.state;

		return (
			<LayoutPrivate>
				<Row>
					<Col lg={{span: 8, offset: 2}}>
						<h2 style={{marginBottom: '2rem'}}>Wczytaj nową definicję dla kalkulatora</h2>
						<Status
							success={success}
							error={error}
							invalid={invalid}
							loading={loading}
						/>
						<Form handleSubmit={this.handleSubmit} handleError={this.handleError}>
							<Select
								name="type"
								value={type}
								label="Rodzaj pliku definicji"
								options={[
									{
										label: 'Wybierz rodzaj pliku',
										value: ''
									},
									{
										label: 'Kalkulator ogrzewania typowego POBE XLS (standard 2022)',
										value: ImportFileType.POBE_HC_XLS_2022
									},
									{
										label: 'Kalkulator ogrzewania typowego POBE XLS (prognoza 2023)',
										value: ImportFileType.POBE_HC_XLS_FORECAST_2023
									},
									{
										label: 'Kalkulator ogrzewania typowego POBE XLS (standard 2023)',
										value: ImportFileType.POBE_HC_XLS_2023
									},
									{
										label: 'Kalkulator ogrzewania typowego POBE XLS (standard 2025)',
										value: ImportFileType.POBE_HC_XLS_2025
									}
								]}
								handleChange={this.handleChange}
								required
							/>

							{
								[ImportFileType.POBE_HC_XLS_2022, ImportFileType.POBE_HC_XLS_FORECAST_2023, ImportFileType.POBE_HC_XLS_2023, ImportFileType.POBE_HC_XLS_2025].includes(type) && (
									<Alert variant="warning">
										<strong>Zatrzymaj się</strong> na chwilę :)<br />
										Jeżeli wykonujesz import to musisz upewnić się, że Twój plik jest poprawnie uzupełniony.<br />
										W przeciwnym wypadku istnieje ryzyko, że wartości zostaną niepoprawnie wczytane, a to przekłada się na niepoprawne wyniki kalkulatora.
									</Alert>
								)
							}

							{
								type && (
									<File
										name="file"
										value={file}
										label="Plik definicji"
										handleChange={this.handleChange}
										required
									/>
								)
							}

							<Button variant="outline-primary" type="submit">
								Zaimportuj nową definicję
							</Button>
						</Form>
					</Col>
				</Row>
			</LayoutPrivate>
		);
	}
}

ImportCalculatorDefinition.propTypes = {
	history: PropTypes.object.isRequired,
	getCalculatorDefinition: PropTypes.func.isRequired,
	imported: PropTypes.bool.isRequired,
	importCalculatorDefinition: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
	error: PropTypes.bool.isRequired
};

export default ImportCalculatorDefinition;
